import axios from "axios";

export const createChangePackage = async (username, changeIdeaPackageVO) => {
    try {
        const {data} = await axios.post("/api/changeIdeaPackage/create",{username, changeIdeaPackageVO});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const viewAllChangeIdeaPackages = async (username) => {
    try {
        const {data} = await axios.get("/api/changeIdeaPackage/viewAll?username=" + username);
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const viewChangePackage = async (username, changeIdeaPackageExternalReference) => {
    try {
        const {data} = await axios.post("/api/changeIdeaPackage/view", {username, changeIdeaPackageExternalReference});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const updateChangePackage = async (username, changeIdeaPackageVO) => {
    try {
        const {data} = await axios.put("/api/changeIdeaPackage/update", {username, changeIdeaPackageVO});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const deleteChangePackage = async (username, externalReference) => {
    try {
        const {data} = await axios.delete("/api/changeIdeaPackage/delete", {data: {username, externalReference}});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}
